<template>
  <div>
    <Loading v-if="isLoading" />
    <div v-else>
      <!-- 定位橫版走勢 -->

      <div class="content-8__controlbar__item">
        <div class="c8-select">
          <div class="c8-select__title">
            <span class="c8-select__title__text" v-text="hmTitle"></span>
          </div>
          <div class="c8-select__content">
            <a
              v-for="hm in hmList"
              :key="`hm-selector-${hm.key}`"
              class="button-outline c8-select__content__item"
              :class="{ active: hm.key === currentHm }"
              href="javascript:;"
              @click="currentHm = hm.key"
            >
              <span class="button-outline__text" v-text="hm.label"></span>
            </a>
          </div>
        </div>
      </div>

      <div style="width: 100%; height: 50vh;">
        <v-chart ref="polar" :options="line" />
      </div>
    </div>
  </div>
</template>

<script>
import { getRuleDetails_web } from '@/api/desktop/trend'
import Loading from '@/components/web/common/Loading'
import {
  hmList
} from '@/utils/flyc-temp/lotteryLib'

function createSeries(name) {
  return {
    name,
    type: 'line',
    symbolSize: 6,
    smooth: true,
    data: [],
    animation: false
  }
}

export default {
  name: 'DingWeiHengBanZouShihContent',
  components: {
    Loading
  },
  props: {
    lotteryCode: {
      type: String,
      default: ''
    },
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      currentHm: 'hm1',

      line: {
        backgroundColor: '#fff',
        color: ['#37A2DA', '#67E0E3', '#9FE6B8', '#F00078', '#BE77FF', '#00DB00', '#FFA042'],
        tooltip: { // hover 顯示的字樣
          trigger: 'axis',
          formatter: (value) => {
            const period = value[0].axisValueLabel
            const hmLabel = this.hmMap[value[0].seriesName]
            const data = value[0].value
            return `${period}期 ${hmLabel} ${data}`
          }
        },
        legend: {
          show: false,
          left: 20,
          // 同時出現很多條線時的show/hide
          selected: {}
        },
        xAxis: {
          // offset: 10,
          // position: 'top',
          type: 'category',
          axisTick: {
            interval: () => true
          },
          boundaryGap: true,
          data: [],
          nameLocation: 'middle',
          name: '期号',
          axisLabel: {
            interval: 0,
            rotate: 0
          },
          nameTextStyle: {
            fontSize: 16,
            padding: [20, 0, 0, 0]
          }
        },
        yAxis: {
          min: 0,
          max: 10,
          interval: 1,
          //   splitNumber: 11,
          type: 'value',
          nameRotate: 0,
          nameLocation: 'middle',
          name: '{x|\n号\n码}',
          data: (new Array(10)).fill().map((nothing, index) => (index + 1)),
          nameTextStyle: {
            rich: {
              x: {
                fontSize: 16,
                padding: 12,
                color: 'black',
                height: 4
              }
            }
          }
        },
        series: []
      },
      isLoading: true
    }
  },
  computed: {
    ...hmList,
    hmMap() {
      return this.hmList.reduce((map, { key, label }) => Object.assign(map, { [key]: label }), {})
    },
    hmTitle() {
      return this.lotteryType === 'pk10' ? '筛选名次: ' : '筛选球位: '
    }
  },
  watch: {
    lotteryCode: {
      immediate: true,
      async handler() {
        const { hmList, currentHm } = this
        this.line.legend.selected = hmList.reduce((map, hm) => Object.assign(map, { [hm.key]: false }), {})
        this.line.legend.selected[currentHm] = true

        await this.setNmList()
        await this.getData()
      }
    },
    currentHm: {
      immediate: true,
      handler(currentHm, previousHm) {
        if (previousHm) {
          this.line.legend.selected[previousHm] = false
        }
        this.line.legend.selected[currentHm] = true
      }
    }
  },
  methods: {
    setNmList() {
      const lotteryType = this.lotteryType

      switch (lotteryType) {
        case 'ssc':
          this.line.yAxis.max = 10
          this.line.series = this.hmList.reduce((list, hm) => list.concat([createSeries(hm.key)]), [])
          break
        case 'kl10':
          this.line.yAxis.max = 21
          this.line.series = this.hmList.reduce((list, hm) => list.concat([createSeries(hm.key)]), [])
          break
        case '11x5': // 兩種都是11選5
        case 'syx5': // 兩種都是11選5
          this.line.yAxis.max = 12
          this.line.series = this.hmList.reduce((list, hm) => list.concat([createSeries(hm.key)]), [])
          break
        default:
          console.warn('DingWeiHengBanZouShihContent: setNmList: lotteryType 對應失敗!', lotteryType)
      }
    },
    async getData() {
      this.isLoading = true

      const [data, error] = await getRuleDetails_web(this.lotteryCode, { count: 30 })
      if (error) return
      this.line.xAxis.data = data.map(el => el.period.slice(-3))
      data.forEach(per => {
        per.balls.forEach((ball, ballIndex) => {
          this.line.series[ballIndex].data.push(ball)
        })
      })

      this.isLoading = false
    }
  }
}
</script>
